// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export interface GeneratedAnalyticsMetadataTextareaComponent {
  name: 'awsui.Textarea';
  label: string;
  properties: {
    value: string;
  };
}
